module.exports = __webpack_public_path__ + "static/media/cara_happy_eyes_close_full.bcbef1e8.png";